import { Selector, State } from "./types";
import { matchRequest } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveWorkloadProjectsRequestPending(
      resourceId,
      from,
      to,
      granularity,
      filter,
      sort,
      size,
    ) {
      const state = getState();
      const index = matchRequest(
        state,
        resourceId,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.request.isPending : false;
    },
    isRetrieveWorkloadProjectsRequestSuccess(
      resourceId,
      from,
      to,
      granularity,
      filter,
      sort,
      size,
    ) {
      const state = getState();
      const index = matchRequest(
        state,
        resourceId,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.request.isSuccessful : false;
    },
    isRetrieveWorkloadProjectsRequestFailure(
      resourceId,
      from,
      to,
      granularity,
      filter,
      sort,
      size,
    ) {
      const state = getState();
      const index = matchRequest(
        state,
        resourceId,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.request.isFailure : false;
    },
    getWorkloadProjectsContent(
      resourceId,
      from,
      to,
      granularity,
      filter,
      sort,
      size,
    ) {
      const state = getState();
      const index = matchRequest(
        state,
        resourceId,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.content : [];
    },
    getWorkloadProjectsCurrentPage(
      resourceId,
      from,
      to,
      granularity,
      filter,
      sort,
      size,
    ) {
      const state = getState();
      const index = matchRequest(
        state,
        resourceId,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.currentPage : 0;
    },
    canLoadMoreWorkloadProjects(
      resourceId,
      from,
      to,
      granularity,
      filter,
      sort,
      size,
    ) {
      const state = getState();
      const index = matchRequest(
        state,
        resourceId,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.canLoadMore : true;
    },
    getWorkloadProjectsTotalElements(
      resourceId,
      from,
      to,
      granularity,
      filter,
      sort,
      size,
    ) {
      const state = getState();
      const index = matchRequest(
        state,
        resourceId,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.totalElements : 0;
    },
  };
}

export { createSelector };
